import { useEffect } from 'react'
import * as storage from 'lib/storage/pageViewAnalyticsStorage'
import { getCurrentPathFromDocument } from 'analytics/snowplow/helpers'

export interface AnalyticsDataAvailableEvent {
  storageKey: string;
  dataType: storage.DataKey;
}

export function usePageViewAnalyticsPriceShare(data?: storage.PageViewAnalyticsPriceShareData) {
  useEffect(() => {
    const currentPath = getCurrentPathFromDocument()
    if (data?.price !== undefined && currentPath) {
      const key = storage.getAnalyticsDataStorageKey(currentPath, storage.ANALYTICS_DATA_TYPE.PRICE)
      storage.set(key, data)

      if (key) {
        document.dispatchEvent(new CustomEvent<AnalyticsDataAvailableEvent>('analytics-data-available', {
          detail: {
            storageKey: key,
            dataType: storage.ANALYTICS_DATA_TYPE.PRICE,
          },
        }))
      }
    }
  }, [data, data?.price])
}
